import React from 'react';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { CustomizedTooltip } from 'components/common/index';

import { TooltipData } from '../../widgetCard.types';
import { CardSlider } from './CardSlider/CardSlider';
import classes from './CardTooltip.module.scss';

const TooltipContent = (props) => {
    return (
        <div className={classes.tooltipContent}>
            <CardSlider {...props} />
        </div>
    );
};

export const CardTooltip = ({ children, ...rest }: TooltipData) => {
    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Top}
            triggerElement={children}
            tooltipContent={<TooltipContent {...rest} />}
        />
    );
};
